import React, { useRef, useEffect } from 'react';
import { InputLabel, MenuItem, Select, Stack } from '@mui/material';

function SelectDashboard({
  label,
  fontFamily,
  fontWeight,
  colorLabel,
  options,
  valueSelect = 'name',
  value = '',
  textColor,
  fontSizeInput,
  fontSize,
  borderColor,
  backgroundColor = 'transparent', 
  onChange = () => {},
}) {
  const selectRef = useRef(null);
  useEffect(() => {
    if (selectRef.current) {
      selectRef.current.style.width = 'auto';
    }
  }, [value]);
  
  return (
    <Stack>
      <InputLabel sx={{ color: colorLabel, fontWeight: fontWeight, fontFamily: fontFamily, fontSize: fontSizeInput }}>
        {label}
      </InputLabel>
      <Select
        ref={selectRef}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent',
            height: 'auto',
          },
          '& .MuiSelect-select': {
            backgroundColor: backgroundColor,
            fontFamily: 'Raleway, sans-serif',
          },
          '& .MuiSelect-root': {
            height: '60%',
            width: '100%',
            color: textColor || 'white',
            fontSize: fontSize || 'inherit',
            fontFamily: 'Raleway, sans-serif'
          },
          '& .MuiInputLabel-root': {
            color: textColor || 'white',
            fontSize: fontSize || 'inherit',
            fontFamily: 'Raleway, sans-serif'
          },
          '& .MuiInputBase-input': {
            color: textColor || 'white',
            fontSize: fontSize || 'inherit',
            fontFamily: 'Raleway, sans-serif'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent',
            fontFamily: 'Raleway, sans-serif'
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent',
            fontFamily: 'Raleway, sans-serif'
          },
          '@media (max-width: 715px)': {
            fontSize: '1.5rem',
            fontFamily: 'Raleway, sans-serif'
          },
        }}
        value={value}
        onChange={onChange}
      >
        {options
          ? options.map((option) => (
              <MenuItem key={`${option._id}`} value={option[valueSelect]}>
                {option.name}
              </MenuItem>
            ))
          : null}
      </Select>
    </Stack>
  );
}

export default SelectDashboard;